export const NOT_PERMISSION_TITLE = 'Não permitido'
export const NOT_PERMISSION_BODY =
  'Você não tem permissão para acessar esse recurso'
